/**
 * User API Exports
 */

export {
  fetchContractorProfile,
  fetchClientProfile,
  fetchProfileReviews,
  fetchMyContractorProfile,
} from './fetchProfile';

export type { FetchProfileParams } from './fetchProfile';

export {
  registerUser,
  verifyEmail,
  loginUser,
  logoutUser,
  resendVerificationEmail,
  changePassword,
  loginWithGoogle,
  getMe,
  completeOAuthRegistration,
} from './auth.api';

export type { OAuthConsentRequest } from './auth.api';

export type {
  ChangePasswordRequest,
  ChangePasswordResponse,
} from './auth.api';

export {
  updateContractorProfile,
  updateContractorLocation,
  getMyContractorProfile,
} from './updateProfile';

export type {
  UpdateContractorProfileDto,
  UpdateLocationDto,
} from './updateProfile';

// ⚠️ DEPRECATED: Old role-based API (kept for backward compatibility)
export {
  addRoleToUser,
  switchUserRole,
  getCurrentUserProfile as getCurrentUserProfileOld,
} from './roles.api';

export type {
  AddRoleResponse,
  SwitchRoleResponse,
} from './roles.api';

// ✅ NEW: Actor-based API (Actor/Persona Architecture)
export {
  getUserActors,
  switchActor,
  switchOrCreateActorByType,
  getCurrentUserProfile,
} from './actors.api';

export type {
  GetActorsResponse,
  SwitchActorResponse,
} from './actors.api';

export {
  updateUserProfile,
  updateActorProfile,
  uploadAvatar,
} from './updateUser';

export type {
  UpdateUserProfileDto,
  UpdateActorDto,
  User,
  Actor,
} from './updateUser';

export {
  getMyPortfolio,
  createPortfolioItem,
  updatePortfolioItem,
  deletePortfolioItem,
  reorderPortfolio,
} from './portfolio';

export type {
  PortfolioItem,
  CreatePortfolioItemDto,
  UpdatePortfolioItemDto,
  ReorderPortfolioDto,
} from './portfolio';

export {
  getCategories,
  getCategoryTree,
  getMyCategories,
  assignCategories,
  removeCategory,
} from './categories';

export type {
  Category,
  ContractorCategory,
  AssignCategoriesDto,
} from './categories';

export {
  getMyServices,
  createService,
  updateService,
  deleteService,
} from './services';

export type {
  Service,
  CreateServiceDto,
  UpdateServiceDto,
} from './services';

export {
  getMyWorkingHours,
  updateWorkingHours,
  getWorkingHoursById,
} from './workingHours';

export type {
  WorkingHoursDay,
  UpdateWorkingHoursDto,
} from './workingHours';

// Client profile API
export {
  fetchMyClientProfile,
  updateClientProfile,
  updateClientLocation,
} from './clientProfile';

export type {
  ClientProfileResponse,
  UpdateClientProfileDto,
  UpdateClientLocationDto,
} from './clientProfile';

// Certificates API
export {
  getMyCertificates,
  uploadCertificate,
  deleteCertificate,
  getCertificatesById,
} from './certificates';

export type { Certificate } from './certificates';

// Social Media API
export {
  getMySocialMediaLinks,
  updateSocialMediaLinks,
  deleteSocialMediaLink,
  getSocialMediaLinksById,
} from './socialMedia';

export type {
  SocialMediaLink,
  SocialMediaLinkInput,
  SocialMediaPlatform,
} from './socialMedia';

// Gallery API
export { uploadGalleryImage } from './gallery';
export type { GalleryUploadResponse } from './gallery';

// Privacy API (PIPEDA Compliance)
export {
  deleteAccount,
  exportUserData,
  updateCookiePreferences,
  downloadUserDataAsJson,
} from './privacy.api';

export type {
  CookiePreferences,
  ExportUserDataResponse,
  UpdateCookiePreferencesRequest,
  UpdateCookiePreferencesResponse,
} from './privacy.api';
